import { initCarousel } from "./modules/carousel.js";

function boot() {
    initCarousel();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
} else {
    boot();
}